$('.realizationSlider__wrapper').slick({
  autoplay: true,
  arrows: true,
  dots: false,
  speed: 400,
  autoplaySpeed: 10000
});
